<template>
    <ul>
        <li v-for="(text,i) of textList" :class="`pad-t-d5 mrg-t-d5 ${i===0? '': 'line-t thick-1 line-neutral'}`">
            <b class="color-yellow mrg-r-1">·</b> <span class="alpha-d8">{{text}}</span>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "list-widget",
        props: ["text-list"]
    }
</script>


// WEBPACK FOOTER //
// src/components/list-widget.vue